import type { ColorPalette } from '../ColorPalette';
import type { ModeInterface } from './ModeInterface';
import type { PaletteStaleListener } from '../types';

/**
 * Shared mode behavior.
 */
export abstract class AbstractMode implements ModeInterface {
	private ignoreUserChoice = false;

	private paletteStaleListener: PaletteStaleListener | null = null;

	setIgnoreUserChoice(ignoreUserChoice: boolean): void {
		this.ignoreUserChoice = ignoreUserChoice;
	}

	ignoresUserChoice(): boolean {
		return this.ignoreUserChoice;
	}

	abstract currentPalette(): ColorPalette;

	abstract type(): string;

	setPaletteStaleListener(listener: PaletteStaleListener): void {
		this.paletteStaleListener = listener;
	}

	dispose(): void {
		this.paletteStaleListener = null;
		this.onDispose();
	}

	/**
	 * Concrete modes override to clear intervals, timeouts, and DOM listeners.
	 */
	protected onDispose(): void {}

	/**
	 * Call when a timer, media query, or other driver may have changed the palette.
	 */
	protected notifyPaletteStale(): void {
		this.paletteStaleListener?.();
	}
}
